import { createEvent, toggleFormEvent } from '@/redux/actions/events'
import { formValidator, resetFormValidator } from '@/redux/actions/validator'
import { IRootState } from '@/redux/types'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IEvent } from '../../../models/events'

function useHandleSubmit(eventState: IEvent) {
  const dispatch = useDispatch()

  const { isValidForm } = useSelector((state: IRootState) => state.validator)

  const handleSubmit = () => {
    dispatch(
      formValidator({
        country: [eventState.country, 'required'],
        languages: [eventState.languages, 'notempty', 'general'],
        title: [eventState.title, 'required|max:50|min:2'],
        startDate: [eventState.startDate, 'required', 'general'],
        endDate: [{ initial: eventState.startDate, final: eventState.endDate }, `required|datemin`, 'general'],
        role: [eventState.role, 'notempty', 'general'],
        method: [eventState.method, 'required'],
        type: [eventState.type, 'required'],
        status: [eventState.status, 'required'],
        visibility: [eventState.visibility, 'required']
      })
    )
  }

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
  useEffect(() => {
    if (isValidForm) {
      dispatch(resetFormValidator())

      let formData = new FormData()
      formData.append('id', String(eventState.id ?? ''))
      formData.append('title', eventState.title)
      formData.append('description', eventState.description)
      formData.append('method', String(eventState.method))
      formData.append('type', String(eventState.type))
      formData.append('status', String(eventState.status.id))
      formData.append('visibility', String(eventState.visibility.id))
      formData.append('role', JSON.stringify(eventState.role))
      formData.append('country', JSON.stringify(eventState.country))
      formData.append('languages', JSON.stringify(eventState.languages))
      formData.append('date_ini', dayjs(eventState.startDate).format('YYYY-MM-DD HH:mm:ss'))

      if (eventState.file !== null) formData.append('file', eventState.file)
      else formData.append('file', '')

      if (eventState.brand !== null) formData.append('brand', JSON.stringify(eventState.brand))
      if (eventState.line !== null) formData.append('line', JSON.stringify(eventState.line))
      if (eventState.speaker !== null) formData.append('speaker', eventState.speaker)
      if (eventState.link !== null) formData.append('link', eventState.link)
      if (eventState.text_button !== null) formData.append('text_button', eventState.text_button)
      if (eventState.background_color !== null) formData.append('background_color', eventState.background_color.hex)
      if (eventState.text_color !== null) formData.append('text_color', eventState.text_color.hex)
      if (eventState.endDate !== null) formData.append('date_end', dayjs(eventState.endDate).format('YYYY-MM-DD HH:mm:ss'))

      dispatch(createEvent(formData))
      handleCloseModalEvent()
    }
  }, [isValidForm])

  const handleCloseModalEvent = () => {
    dispatch(resetFormValidator())
    dispatch(toggleFormEvent())
  }

  return { handleSubmit, handleCloseModalEvent }
}
export default useHandleSubmit
